import ActionInput from 'automation-ui-action-features/action-inputs/records/ActionInput';
import { Map as ImmutableMap, List, Record } from 'immutable';
export default class QueryParam extends Record({
  variables: null
}, 'QueryParam') {
  constructor(props = {}) {
    const propMap = ImmutableMap(props);
    const variables = propMap.get('variables');
    super(propMap.set('variables', List(variables.map(variable => new ActionInput(variable)))));
  }
  getVariables() {
    return this.get('variables');
  }
  setVariables(newVariables) {
    return this.set('variables', newVariables);
  }
}